import type { NoyauTextField } from '@/lib/noyau-texts-draft';

/**
 * The marks of Réglages > Noyaux (noyau.md §6.3, issue #148), for the unit
 * tests, `e2e/tests/reglages-noyaux.spec.ts` and
 * `e2e/screenshots-reglages-noyaux.mjs` - the last two RECOPY them, since the
 * e2e suite does not compile the frontend.
 *
 * The head, the history and the boxes are the layer's and carry the
 * `noyaux-` prefix of `NOYAU_TEXTS_WORDING` (`noyaux-entete`,
 * `noyaux-enregistrer`, `noyaux-historique-ouvrir`, `noyaux-aucune-version`,
 * `noyaux-tiroir`, `noyaux-boite-enregistrer`); what is here is the tab's own.
 */
export const NOYAU_TEXTS_IDS = {
  /** The six cards, each carrying `data-noyau` with its triplet. */
  card: 'noyaux-carte',
  /** « 2 sur 3 », in the head of each card. */
  cardCount: 'noyaux-carte-compteur',
  /** « 7 sur 18 remplis » - shown while a text is missing, and always before the v1. */
  total: 'noyaux-compteur',
  /** The callout of the state without any version (§6.4). */
  empty: 'noyaux-vide',
  /** The grid of the six cards. */
  grid: 'noyaux-grille',
  /** The note under the grid, once a version exists. */
  note: 'noyaux-note',
} as const;

/** The unaccented slug of each field, for its three marks. */
export const NOYAU_TEXT_FIELD_SLUG: Readonly<Record<NoyauTextField, string>> = {
  firstText: 'premier',
  secondText: 'second',
  portrait: 'portrait',
};

/** The three marks of one field of a card - `noyaux-texte-premier` and its two neighbours. */
export function noyauTextFieldIds(field: NoyauTextField): {
  readonly toolbar: string;
  readonly text: string;
  readonly count: string;
} {
  const slug = NOYAU_TEXT_FIELD_SLUG[field];
  return {
    toolbar: `noyaux-barre-${slug}`,
    text: `noyaux-texte-${slug}`,
    count: `noyaux-caracteres-${slug}`,
  };
}
